<template>
	<el-table :summary-method="getSummaries" show-summary v-if="!loading && propsData && show && tabData.length > 0"
		height="100%" :data="tabData" ref="table" style="width: 100%;max-height:100%">
		<el-table-column key="-2" fixed prop="loopName" label="回路名称" width="220">
		</el-table-column>
		<el-table-column key="-1" fixed prop="total" label="总用电量" width="200">
		</el-table-column>
		<el-table-column v-for="(item, index) in titles" :key="index" :prop="item" :label="item" width="108">
			<template slot-scope="scope">
				<span v-if="scope.row[item] != '--'">{{ scope.row[item] }} kWh</span>
				<span v-else class="grey">--</span>
			</template>
		</el-table-column>
	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
import {
	dayStart,
	dayEnd,
	monthStart,
	yearStart,
	monthEnd,
	yearEnd,
	monthDays,
	currentDay,
	dateFormat
} from "../../../util/DateUtil";
import { INFLUX_QUERY } from "../../../api/power"
import exportExcel from "../../../util/excel";
import { floatFormat } from "../../../util/MathUtil"
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
export default {
	name: "PowerTime",
	props: {
		loops: Array,
		range: String,
		date: Date
	},
	data() {
		return {
			titles: [],
			loading: false,
			tabData: [],
			show: false,
		}
	},
	watch: {
		diagramStatus(n) {
			if (this.$route.query.uid === 'PowerTime') {
				if (n.type === 'excel' && this.tabData.length > 0) {

					let data = [
						['回路名称', '总用电量']
					]

					this.titles.forEach(t => {
						data[0].push(t)
					})

					this.tabData.forEach(d => {
						data.push([d.loopName, d.total, ...this.titles.map(t => d[t])])
					})
					// // const sheet = this.xlsxAddStyle(data);
					// exportExcel(data, '用电量时段报表', [])
					const workbook = new ExcelJS.Workbook();
					// 创建带有红色标签颜色的工作表
					const sheet = workbook.addWorksheet('Sheet1');

					let letter = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI']
					if (this.range == 'day') {
						letter = letter.filter((e, i) => i < 26)
					} else if (this.range == 'month') {
						letter = letter.filter((e, i) => i < monthDays(this.date) + 2)
					} else {
						letter = letter.filter((e, i) => i < 14)
					}


					let sheetName = ["用电量时段" + this.dateName + "报表", this.selProjectName, '日期：' + this.timeDate]
					let style = {
						fill: {
							type: 'gradient',
							gradient: 'angle',
							degree: 0,
							stops: [
								{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
								{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
								{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
							]
						},
						font20: {
							name: 'Arial',
							size: 20,
							bold: true
						},
						font12bold: {
							name: 'Arial',
							size: 12,
							bold: true
						},
						font12: {
							name: 'Arial',
							size: 12,
							// bold: true
						},
						alignmentCenter: { vertical: 'middle', horizontal: 'center' },
						alignmentLeft: { vertical: 'middle', horizontal: 'left' },
						border: {
							top: { style: 'thin' },
							left: { style: 'thin' },
							bottom: { style: 'thin' },
							right: { style: 'thin' }
						}
					}

					//处理一二层

					sheet.mergeCells(letter[0] + '1:' + letter[letter.length - 1] + '1');
					sheet.getCell(letter[0] + '1').value = sheetName[0]
					sheet.getCell(letter[0] + '1').font = style.font20
					sheet.getCell(letter[0] + '1').alignment = style.alignmentCenter

					sheet.mergeCells('A2:B2');
					sheet.mergeCells('C2:' + letter[letter.length - 1] + '2');
					sheet.getCell('A2').value = sheetName[1]
					sheet.getCell('C2').value = sheetName[2]
					sheet.getRow(2).font = style.font12bold
					sheet.getRow(2).alignment = style.alignmentLeft
					const rows = sheet.getRows(1, 2);
					rows.map(e => { e.height = 50; return e })

					//表格设置
					let columns = []
					data[0].forEach(item => {
						columns.push({
							name: item,
						})
					})
					sheet.addTable({
						name: 'MyTable',
						ref: 'A3', // 表格左上角的位置
						headerRow: true,
						totalsRow: false,
						style: {
							theme: 'TableStyleLight1',
							font: {
								name: 'Arial',
								size: 12,
								// bold: true
							},
						},
						//            showRowStripes: true,
						columns: columns,
						rows: data.slice(1),
					})

					//表格头部样式
					sheet.getRow(3).height = 59
					sheet.getRow(3).font = style.font12bold

					letter.forEach(item => {
						sheet.getCell(item + '3').fill = style.fill
						sheet.getCell(item + '3').border = style.border
						sheet.getRow(3).alignment = style.alignmentCenter
					})
					data.slice(1).forEach((item, index) => {
						sheet.getRow(4 + index).height = 38
						sheet.getRow(4 + index).font = style.font12
						letter.forEach((e, i) => {
							if (i <= 1) {
								sheet.getColumn(e).width = 26
							} else {
								sheet.getColumn(e).width = 12
							}
							sheet.getCell(e + (4 + index)).border = style.border
						})

						sheet.getRow(4 + index).alignment = style.alignmentCenter
					})


					// workbook.xlsx.writeFile('test.xlsx')
					workbook.xlsx.writeBuffer().then(buffer => {
						FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
					})
				} else {
					this.$message.warning("无图表数据！")
				}
			}
		},
		propsData(n) {
			this.tabData = []
			this.generateTitle()
			this.requestData()
		},
	},
	computed: {

		selProjectName() {
			return this.$store.getters.selProjectInfo.projectName;
		},
		diagramStatus() {
			return this.$store.state.project.diagramStatus
		},
		propsData() {
			return [
				this.date,
				this.range,
				this.loops
			]
		},

		dateName() {
			switch (this.range) {
				case 'day':
					this.timeDate = dateFormat("YY-mm-dd", this.date)
					return "日"
					break;
				case 'week':
					this.timeDate = dateFormat("YY-mm-dd", this.date)
					return "周"
					break;
				case 'month':
					this.timeDate = dateFormat("YY-mm", this.date)
					return "月"
					break;
				case 'year':
					this.timeDate = dateFormat("YY", this.date)
					return "年"
					break;
				default:
					this.timeDate = dateFormat("YY-mm-dd", this.date)
					return "日"
					break;
			}
		},
	},
	methods: {
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总计';
					return;
				}
				const values = data.map(item => Number(item[column.property].split(" ")[0]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index] = sums[index].toFixed(2) + ' kWh';
				}
			});

			return sums;
		},
		getLoopName(code) {
			return this.loops.filter(loop => {
				//return loop.loopUrl === code
				return code.indexOf(loop.subLoopUrl) !== -1
			})[0].loopName
		},
		generateTitle(n) {
			if (!n) {
				n = this.range
			}
			switch (n) {
				case "day":
					this.titles = []
					for (let i = 0; i < 24; i++) {
						this.$set(this.titles, i, i + '点')
					}
					break
				case "month":
					this.titles = []
					for (let i = 0; i < monthDays(this.date); i++) {
						this.$set(this.titles, i, i + 1 + '日')
					}
					break
				case "year":
					this.titles = []
					for (let i = 0; i < 12; i++) {
						this.$set(this.titles, i, i + 1 + '月')
					}
					break
			}

			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		keyGenerate(time) {
			let date = new Date(time)
			switch (this.range) {
				case "day":
					let hours = date.getHours();
					return hours + '点'
				case "month":
					return currentDay(date) + '日'
				case "year":
					return date.getMonth() + 1 + '月'
			}
		},
		async requestData() {

			if (this.loops.length <= 0) {
				return
			}

			this.loading = true

			let ids = this.loops.map(l => l.loopId);
			let start
			let end
			let group

			switch (this.range) {
				case "day":
					start = dayStart(this.date)
					end = dayEnd(this.date)
					group = '1h'
					break
				case "month":
					start = monthStart(this.date)
					end = monthEnd(this.date)
					group = '1d'
					break
				case "year":
					start = yearStart(this.date)
					end = yearEnd(this.date)
					group = '1d'
					break

			}

			let res = await INFLUX_QUERY(ids, start, end, group, ["PA_total"])

			let influxData = res.data.data.influxData

			console.log(influxData)

			let list = []

			try {

				influxData.results.forEach(result => {
					result.series.forEach(serie => {
						let obj = {}
						let sum = 0
						serie.values.forEach(val => {
							let k = this.keyGenerate(val[0])
							let v = Number(obj[k])

							if (v) {
								if (v === '--') {
									obj[k] = (val[4] !== null ? val[4] : '--')
								} else {
									obj[k] = floatFormat((val[4] !== null ? val[4] : 0) + v, 2)
								}
							} else {
								obj[k] = val[4] !== null ? floatFormat(val[4], 2) : '--'
							}
							obj.code = serie.tags.code
							sum += val[4] ? val[4] : 0
						})
						obj.total = floatFormat(sum, 2) + ' kWh';
						obj.loopName = this.getLoopName(serie.tags.code)
						console.log("dsd",obj)
						list.push(obj)
					})
				})
			} catch (e) {

			}
			console.log(list);

			// list.sort((a, b) => {
			// 	return b.total - a.total
			// })
			this.tabData = list
			console.log(this.tabDate, "this.tabData")
			this.loading = false
		}
	},
	mounted() {
		this.generateTitle()
		this.requestData()
	}
}
</script>

<style scoped lang="less">
.tip {
	width: 100%;
	height: 100%;
	font-size: 16rem;
	color: #8c939d;
}

.loading {
	width: 28rem;
	height: 28rem;
	animation: loading 1s linear infinite;
}

@keyframes loading {
	0% {
		transform: rotate(0);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>